import { getUserAnswerToQuestion } from "../../../../core/store/currentFormSlice";
import { useMainStore } from "../../../../core/store/mainStore";
import { SignContractComponent } from "./SignContractComponent";

type Props = {
  questionId: string;
  answerId: string;
  contractToSign?: {
    documentId: string;
    documentUrl: string;
    displayName: string;
    isLocalDocument?: boolean;
  };
};

export const ContractAnswer = ({
  questionId,
  answerId,
  contractToSign,
}: Props) => {
  if (!contractToSign) {
    return null;
  }
  const patientAnswer = useMainStore((state) =>
    getUserAnswerToQuestion(state, answerId),
  );
  const termsAccepted = !!patientAnswer?.contractDetails?.signedAt;
  const setUserAnswerToQuestion = useMainStore(
    (state) => state.setUserAnswerToQuestion,
  );
  const handleToggleTermsAccepted = () => {
    if (termsAccepted) {
      setUserAnswerToQuestion(
        questionId,
        {
          id: answerId,
          contractDetails: {
            documentId: contractToSign?.documentId,
            documentUrl: contractToSign?.documentUrl,
            displayName: contractToSign?.displayName,
            signedAt: undefined,
          },
        },
        answerId,
      );
    } else {
      setUserAnswerToQuestion(
        questionId,
        {
          id: answerId,
          contractDetails: {
            documentId: contractToSign?.documentId,
            documentUrl: contractToSign?.documentUrl,
            displayName: contractToSign?.displayName,
            signedAt: new Date().toISOString(),
          },
        },
        answerId,
      );
    }
  };
  return (
    <SignContractComponent
      fileUrl={contractToSign?.documentUrl}
      fileName={contractToSign?.displayName}
      onAcceptTerms={handleToggleTermsAccepted}
      termsAccepted={!!termsAccepted}
    />
  );
};
